export const ProposalStatus = {  
    Pendiente: { id: "04099B61-54A4-4F89-AA5D-CA0FF7B66823",  nombre: "Pendiente" },
    Aprobada: { id: "0906A413-C53C-408A-A11C-C69B660EC7D7", nombre: "Aprobada" },
    Rechazada: { id: "144E42C8-EE53-4145-A01A-6324255A7234", nombre: "Rechazada" },
    AceptadaConObservaciones: { id: "52C7A580-2B9E-4E05-9423-D91F026944C7", nombre: "Aceptada con observaciones" },
    EnEdicion: {id: "F2BF6926-E286-40C3-81D7-A132357CA095", nombre: "En edición"},
    EnEvaluacion: {id: "8AEC6587-A0B7-46F6-B5BB-5286EF0963E3", nombre: "En evaluación"},
    EnDictamenFinal: {id: "26E72C67-C3E4-44E5-A418-11A782B7E47D", nombre: "En dictamen final"}
};
